import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useOutletContext } from 'react-router-dom'
import useCompanyConfig from '../hooks/api/useCompanyConfig'

import WizardContainer from './shared/WizardContainer'
import { Settings } from '@mui/icons-material'
import { SUPPORT_NUMBER } from '../constants'

const SUBSCRIPTION_COST = 49

const MagicButton = () => {
  const { navigateToNext } = useOutletContext()

  const { companyConfig, setCompanyConfig, updateCompanyConfig } =
    useCompanyConfig()

  const submit = () => {
    const newConfig = {
      ...companyConfig,
      hasFinishedWizard: true,
    }

    setCompanyConfig(newConfig)

    updateCompanyConfig(newConfig).then(navigateToNext).catch(navigateToNext)
  }

  return (
    <WizardContainer>
      <Typography sx={{ mb: 2 }}>
        Thank you for joining us in the wonderful world of StartUP CRM. As a
        reminder, your initial 30 day evaluation period clock has begun. At the
        end of the evaluation period, you can choose to continue services for $
        {SUBSCRIPTION_COST} a month or stop using it at no cost. There are no
        long term contracts with StartUP CRM.
      </Typography>
      <Typography sx={{ mb: 2 }}>
        If you have questions, you can refer to the easy-to-follow training
        videos in the support section or call our support number at:{' '}
        <b>{SUPPORT_NUMBER}.</b> As you go through the journey of using the
        system, we look forward to any and all feedback that you can provide us
        to help enhance your experience.
      </Typography>
      <Typography sx={{ mb: 2 }}>
        We appreciate the opportunity to partner with you and we are committed
        to empowering you to utilize the system in a way that will be beneficial
        to your business’s success.
      </Typography>

      <Typography sx={{ mb: 2 }}>
        Within the system, you'll have the option of bulk importing your
        existing accounts. You can find it in the{' '}
        <Settings color={'primary'} sx={{ mb: '-0.4rem' }} /> Settings section.
      </Typography>

      <Typography sx={{ mb: 2 }}>
        It’s time to start using your custom built CRM. Without further ado,
        take a deep breath, click your toes together three times, and hit The
        Magic Button!
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button variant={'contained'} onClick={submit}>
          MAGIC BUTTON
        </Button>
      </Box>
    </WizardContainer>
  )
}

export default MagicButton
